(function (module) {
    'use strict';

    function EditAppCtrl(
        utils,
        $scope,
        Display,
        Playlist,
        Group,
        WS,
        $http,
        $q,
        $stateParams,
        $state,
        App,
        AppTemplate,
        Store,
        envService,
        Popup,
        Integration,
        IntegrationTemplate,
        Includes,
        ListModifier,
        $mdDialog,
        $mdToast,
        $timeout,
        achieversSettingsMigration,
        limitControls,
        editAppConnect,
        formlyValidationMessages,
        ngCopy,
        fetchAppTemplate,
        fetchApp,
        saveForceEmit,
        seedTemplateDefaults,
        editAppSavePayload,
    ) {
        const CUSTOM_ACTIVE_CORNERS = [
            {
                key: 'theme',
                type: 'select',
                defaultValue: 'light',
                templateOptions: {
                    label: 'Active Corners Font Colour',
                    options: [
                        {
                            name: 'Light Font',
                            value: 'dark',
                        },
                        {
                            name: 'Dark Font',
                            value: 'light',
                        },
                    ],
                },
            },
            {
                key: 'topLeft.type',
                type: 'select',
                defaultValue: null,
                templateOptions: {
                    label: 'Top Left',
                    options: [
                        {
                            name: 'None',
                            value: null,
                        },
                        {
                            name: 'Clock',
                            value: 'clock',
                        },
                        {
                            name: 'Date & Time',
                            value: 'date',
                        },
                        {
                            name: 'Logo',
                            value: 'logo',
                        },
                        {
                            name: 'Text',
                            value: 'text',
                        },
                        {
                            name: 'Weather',
                            value: 'weather',
                        },
                    ],
                },
            },
            {
                key: 'topLeft.text',
                className: 'formly-sub-option',
                type: 'textarea',
                hideExpression: "model.topLeft.type !== 'text'",
                templateOptions: {
                    label: 'Text',
                },
            },
            {
                key: 'topLeft.timezone',
                className: 'formly-sub-option',
                type: 'moment-timezone-select',
                defaultValue: 'Europe/London',
                hideExpression: "model.topLeft.type !== 'date' && model.topLeft.type !== 'clock'",
                templateOptions: {
                    label: 'Time Zone',
                },
            },
            {
                key: 'topLeft.time24vs12',
                className: 'formly-sub-option',
                type: 'select',
                hideExpression: "model.topLeft.type !== 'date' && model.topLeft.type !== 'clock'",
                defaultValue: '24h',
                templateOptions: {
                    label: 'Time format',
                    options: [
                        {
                            name: '24h',
                            value: '24h',
                        },
                        {
                            name: '12h',
                            value: '12h',
                        },
                    ],
                },
            },
            {
                key: 'topLeft.logo',
                className: 'formly-sub-option',
                type: 'formlySinglePicker',
                hideExpression: "model.topLeft.type !== 'logo'",
                templateOptions: {
                    pickerBtnText: 'Pick your logo',
                },
            },
            {
                key: 'topLeft.location',
                type: 'formlyGeolocation',
                hideExpression: "model.topLeft.type !== 'weather'",
                templateOptions: {
                    label: 'Location',
                    required: true,
                    mapEl: 'topLeftMap',
                },
            },
            {
                key: 'topLeft.tempShowIn',
                type: 'select',
                hideExpression: "model.topLeft.type !== 'weather'",
                defaultValue: 'celsius',
                templateOptions: {
                    label: 'Show temperature in',
                    options: [
                        {
                            name: 'Celsius',
                            value: 'celsius',
                        },
                        {
                            name: 'Fahrenheit',
                            value: 'fahrenheit',
                        },
                    ],
                },
            },
            {
                key: 'topRight.type',
                type: 'select',
                defaultValue: null,
                templateOptions: {
                    label: 'Top Right',
                    options: [
                        {
                            name: 'None',
                            value: null,
                        },
                        {
                            name: 'Clock',
                            value: 'clock',
                        },
                        {
                            name: 'Date & Time',
                            value: 'date',
                        },
                        {
                            name: 'Logo',
                            value: 'logo',
                        },
                        {
                            name: 'Text',
                            value: 'text',
                        },
                        {
                            name: 'Weather',
                            value: 'weather',
                        },
                    ],
                },
            },
            {
                key: 'topRight.text',
                type: 'textarea',
                hideExpression: "model.topRight.type !== 'text'",
                templateOptions: {
                    label: 'Text',
                },
            },
            {
                key: 'topRight.timezone',
                type: 'moment-timezone-select',
                hideExpression: "model.topRight.type !== 'date' && model.topRight.type !== 'clock'",
                defaultValue: 'Europe/London',
                templateOptions: {
                    label: 'Time Zone',
                },
            },
            {
                key: 'topRight.time24vs12',
                className: 'formly-sub-option',
                type: 'select',
                hideExpression: "model.topRight.type !== 'date' && model.topRight.type !== 'clock'",
                defaultValue: '24h',
                templateOptions: {
                    label: 'Time format',
                    options: [
                        {
                            name: '24h',
                            value: '24h',
                        },
                        {
                            name: '12h',
                            value: '12h',
                        },
                    ],
                },
            },
            {
                key: 'topRight.logo',
                type: 'formlySinglePicker',
                hideExpression: "model.topRight.type !== 'logo'",
                templateOptions: {
                    pickerBtnText: 'Pick your logo',
                },
            },
            {
                key: 'topRight.location',
                type: 'formlyGeolocation',
                hideExpression: "model.topRight.type !== 'weather'",
                templateOptions: {
                    label: 'Location',
                    required: true,
                    mapEl: 'topRightMap',
                },
            },
            {
                key: 'topRight.tempShowIn',
                type: 'select',
                hideExpression: "model.topRight.type !== 'weather'",
                defaultValue: 'celsius',
                templateOptions: {
                    label: 'Show temperature in',
                    options: [
                        {
                            name: 'Celsius',
                            value: 'celsius',
                        },
                        {
                            name: 'Fahrenheit',
                            value: 'fahrenheit',
                        },
                    ],
                },
            },
            {
                key: 'bottomLeft.type',
                type: 'select',
                defaultValue: null,
                templateOptions: {
                    label: 'Bottom Left',
                    options: [
                        {
                            name: 'None',
                            value: null,
                        },
                        {
                            name: 'Clock',
                            value: 'clock',
                        },
                        {
                            name: 'Date & Time',
                            value: 'date',
                        },
                        {
                            name: 'Logo',
                            value: 'logo',
                        },
                        {
                            name: 'Text',
                            value: 'text',
                        },
                        {
                            name: 'Weather',
                            value: 'weather',
                        },
                    ],
                },
            },
            {
                key: 'bottomLeft.text',
                type: 'textarea',
                hideExpression: "model.bottomLeft.type !== 'text'",
                templateOptions: {
                    label: 'Text',
                },
            },
            {
                key: 'bottomLeft.timezone',
                type: 'moment-timezone-select',
                defaultValue: 'Europe/London',
                hideExpression: "model.bottomLeft.type !== 'date' && model.bottomLeft.type !== 'clock'",
                templateOptions: {
                    label: 'Time Zone',
                },
            },
            {
                key: 'bottomLeft.time24vs12',
                type: 'select',
                hideExpression: "model.bottomLeft.type !== 'date' && model.bottomLeft.type !== 'clock'",
                defaultValue: '24h',
                templateOptions: {
                    label: 'Time format',
                    options: [
                        {
                            name: '24h',
                            value: '24h',
                        },
                        {
                            name: '12h',
                            value: '12h',
                        },
                    ],
                },
            },
            {
                key: 'bottomLeft.logo',
                type: 'formlySinglePicker',
                hideExpression: "model.bottomLeft.type !== 'logo'",
                templateOptions: {
                    pickerBtnText: 'Pick your logo',
                },
            },
            {
                key: 'bottomLeft.location',
                type: 'formlyGeolocation',
                hideExpression: "model.bottomLeft.type !== 'weather'",
                templateOptions: {
                    label: 'Location',
                    required: true,
                    mapEl: 'bottomLeftMap',
                },
            },
            {
                key: 'bottomLeft.tempShowIn',
                type: 'select',
                hideExpression: "model.bottomLeft.type !== 'weather'",
                defaultValue: 'celsius',
                templateOptions: {
                    label: 'Show temperature in',
                    options: [
                        {
                            name: 'Celsius',
                            value: 'celsius',
                        },
                        {
                            name: 'Fahrenheit',
                            value: 'fahrenheit',
                        },
                    ],
                },
            },
            {
                key: 'bottomRight.type',
                type: 'select',
                defaultValue: null,
                templateOptions: {
                    label: 'Bottom Right',
                    options: [
                        {
                            name: 'None',
                            value: null,
                        },
                        {
                            name: 'Clock',
                            value: 'clock',
                        },
                        {
                            name: 'Date & Time',
                            value: 'date',
                        },
                        {
                            name: 'Logo',
                            value: 'logo',
                        },
                        {
                            name: 'Text',
                            value: 'text',
                        },
                        {
                            name: 'Weather',
                            value: 'weather',
                        },
                    ],
                },
            },
            {
                key: 'bottomRight.text',
                type: 'textarea',
                hideExpression: "model.bottomRight.type !== 'text'",
                templateOptions: {
                    label: 'Text',
                },
            },
            {
                key: 'bottomRight.timezone',
                type: 'moment-timezone-select',
                defaultValue: 'Europe/London',
                hideExpression: "model.bottomRight.type !== 'date' && model.bottomRight.type !== 'clock'",
                templateOptions: {
                    label: 'Time Zone',
                },
            },
            {
                key: 'bottomRight.time24vs12',
                type: 'select',
                hideExpression: "model.bottomRight.type !== 'date' && model.bottomRight.type !== 'clock'",
                defaultValue: '24h',
                templateOptions: {
                    label: 'Time format',
                    options: [
                        {
                            name: '24h',
                            value: '24h',
                        },
                        {
                            name: '12h',
                            value: '12h',
                        },
                    ],
                },
            },
            {
                key: 'bottomRight.logo',
                type: 'formlySinglePicker',
                hideExpression: "model.bottomRight.type !== 'logo'",
                templateOptions: {
                    pickerBtnText: 'Pick your logo',
                },
            },
            {
                key: 'bottomRight.location',
                type: 'formlyGeolocation',
                hideExpression: "model.bottomRight.type !== 'weather'",
                templateOptions: {
                    label: 'Location',
                    required: true,
                    mapEl: 'bottomRightMap',
                },
            },
            {
                key: 'bottomRight.tempShowIn',
                type: 'select',
                hideExpression: "model.bottomRight.type !== 'weather'",
                defaultValue: 'celsius',
                templateOptions: {
                    label: 'Show temperature in',
                    options: [
                        {
                            name: 'Celsius',
                            value: 'celsius',
                        },
                        {
                            name: 'Fahrenheit',
                            value: 'fahrenheit',
                        },
                    ],
                },
            },
        ];

        this.setDefault = () => {
            //TODO: MAY NEED TO BE MOVED ELSEWHERE
            formlyValidationMessages.messages = {
                pattern: ($viewValue, $modelValue, scope) => {
                    if (scope.to.patternMessage) {
                        return scope.to.patternMessage;
                    } else {
                        return `${scope.to.label} is invalid`;
                    }
                },
                required: ($viewValue, $modelValue, scope) => {
                    if (scope.to.requiredMessage) {
                        return scope.to.requiredMessage;
                    } else {
                        return 'This field is required';
                    }
                },
                min: ($viewValue, $modelValue, scope) => {
                    if (scope.to.minMessage) {
                        return scope.to.minMessage;
                    } else {
                        return `${scope.to.label} is invalid`;
                    }
                },
                max: ($viewValue, $modelValue, scope) => {
                    if (scope.to.maxMessage) {
                        return scope.to.maxMessage;
                    } else {
                        return `${scope.to.label} is invalid`;
                    }
                },
            };

            this.app = null;
            this.errors = {};
            this.files = [];
            this.cache = $stateParams.preview ? $stateParams.preview : null;
            this.dynamic = null;
            this.previewDataSource = 'live';
            this.previewRequestId = 0;
            this.samplePreviewNow = new Date();
            this.samplePreviewNotice = null;
            this.appTemplate = null;
            this.mode = $stateParams.route;
            this.stateName = $state.current.name;
            this.orientation = 'landscape';
            this.orientationClicked = false;
            this.dataLoaded = true;
            this.animationFormOptions = {
                watchAllExpressions: true,
                data: {
                    disableAnimationType: false,
                    disableAnimationTiming: false,
                    disableAnimationDuration: false,
                },
            };
            this.flex1 = 50;
            this.flex2 = 50;
            this.changeArrow = false;
        };

        this.$onDestroy = () => {};

        this.getData = () => {
            // ADDING APP
            if (this.mode === 'add') {
                if ($stateParams.appTemplate) {
                    this.appTemplate = $stateParams.appTemplate;
                }

                this.getAppTemplate($stateParams.appTemplateId).then((appTemplate) => {
                    // Direct/deep links to /app-store/:appTemplateId/add bypass
                    // the store-list filter; re-apply the alpha/beta gate here
                    // so a gated app template is never rendered for an account
                    // without the flag. No alpha flag -> you don't see it.
                    if (appTemplate && filterApps([appTemplate], Store.getCurrentAccount()).length === 0) {
                        $state.go('root.app-store');
                        return;
                    }

                    if (appTemplate.realm === 'custom') {
                        _.set(appTemplate, 'fields.settings.corners', CUSTOM_ACTIVE_CORNERS);
                    }

                    // Heal templates that still carry the old self-writing
                    // expressionProperties (they corrupt the formly form). See
                    // limit-controls.js.
                    limitControls.healSelfWritingExpressions(appTemplate);

                    // Seed the template's declared formly defaults into the model
                    // BEFORE assigning this.appTemplate — that assignment is what
                    // supplies app-template-id to app-preview-wrapper and triggers
                    // its $onChanges -> fetchDynamicForCurrentData(). Without a
                    // populated app.data at that moment the wrapper bails on its
                    // `if (!data) return false` guard and never requests a feed,
                    // so an app whose select already reads "Recognition" previewed
                    // as "No Achievers content" until the user picked another
                    // option. See seed-template-defaults.js.
                    this.ensurePreviewAppModel();
                    seedTemplateDefaults(_.get(appTemplate, 'fields.data'), this.app.data);

                    this.appTemplate = Store.setSingleModelData('appTemplates', appTemplate.id, appTemplate);

                    if (appTemplate.slug === 'gallery-slider') {
                        this.getFiles();
                    }

                    if (appTemplate.integrationTemplate) {
                        this.getIntegrationTemplate(appTemplate).then(this.setIntegrationTemplate);
                        this.getIntegrations(appTemplate).then(this.setIntegrations);
                    }

                    if (appTemplate.appSchemaSource) {
                        this.getSchemaOverride(appTemplate).then(this.setSchemaOverride);
                    }
                });
            }

            // EDITING APP
            if (this.mode === 'edit') {
                if ($stateParams.app && $stateParams.app.appTemplate) {
                    this.appTemplate = $stateParams.app.appTemplate;
                }

                this.getApp($stateParams.appId)
                    .then(utils.handlePermissions)
                    .then((app) => {
                        achieversSettingsMigration.migrateAchieversDataSettings(app, {
                            $timeout,
                            getForm: () => this.form,
                        });

                        // Existing app instances were saved with a copy of the
                        // old app-template whose limitValue/spotlightFilter fields
                        // self-wrote their own model key, which breaks the formly
                        // form (input disappears, radio won't update). Strip those
                        // so saved apps render the corrected form. See
                        // limit-controls.js.
                        limitControls.healSelfWritingExpressions(app.appTemplate);

                        if (app.appTemplate.realm === 'custom') {
                            _.set(app, 'appTemplate.fields.settings.corners', CUSTOM_ACTIVE_CORNERS);
                        }

                        this.app = Store.setSingleModelData('apps', app.id, app);
                        this.appTemplate = Store.setSingleModelData('appTemplates', app.appTemplate.id, app.appTemplate);

                        if (app.appTemplate.slug === 'gallery-slider') {
                            this.getFiles();
                        }

                        if (app.appTemplate.integrationTemplate) {
                            this.getIntegrationTemplate(app.appTemplate).then(this.setIntegrationTemplate);
                            this.getIntegrations(app.appTemplate).then(this.setIntegrations);
                        }

                        console.log('app.appTemplate', app.appTemplate);
                        console.log('app.appTemplate.appSchemaSource', app.appTemplate.appSchemaSource);
                        if (app.appTemplate.appSchemaSource) {
                            this.getSchemaOverride(app.appTemplate).then(this.setSchemaOverride);
                        }

                        // Only fetch the magic-link token for users who may manage
                        // it. The API is UI-gated, so an ungated fetch here would
                        // pull the token into the network response / controller
                        // state for any account member on edit-page load, despite
                        // the hidden button. Gate the fetch, not just the UI. (#841)
                        if (this.canManageMagicLink) {
                            this.getMagicLink(app.id).then(this.setMagicLink);
                        }

                        if (!$scope.$$phase) {
                            $timeout(() => {
                                $scope.$apply();
                            });
                        }
                    })
                    .catch((error) => {
                        console.log({ error });
                        this.loading = false;
                    });
            }
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.$onInit = () => {
            this.account = Store.getCurrentAccount();
            // Magic links are alpha-gated: an alpha account grants all its
            // users, and the internal email allow-list remains as an escape
            // hatch. The API enforces the same rule server-side.
            this.canManageMagicLink = canManageMagicLink(Store.getCurrentUser(), this.account);
            this.SLS_URI = envService.read('SLS_URI');
            const features = envService.read('features') || {};
            this.samplePreviewEnabled = features.sampleAppPreview === true;

            try {
                this.API_URI = envService.read('API_URI');
            } catch (e) {
                /* guard: envService may throw in some environments */
            }
            try {
                this.PLAYER_URI = envService.read('PLAYER_URI');
            } catch (e) {
                /* guard: envService may throw in some environments */
            }

            this.setDefault();
            this.getData();

            $scope.$watchCollection('$ctrl.app.data.files', this.onFilesChange);
            // Clear the "Limit by" amount whenever the mode changes, so the field
            // reopens blank for the new mode (no stale value across Days<->Count
            // or after No limit). A $watch, not a self-writing expressionProperty
            // (which corrupts the formly form). See limit-controls.js.
            $scope.$watch('$ctrl.app.data.limitBy', (next, prev) => {
                if (this.app && this.app.data) {
                    limitControls.clearLimitValueOnModeChange(this.app.data, next, prev);
                }
            });
            $scope.$watch('$ctrl.app.data', () => {
                this.updateSamplePreviewNotice();
            }, true);
            $scope.$watch('$ctrl.dynamic', () => {
                this.updateSamplePreviewNotice();
            }, true);
            $scope.$watch('$ctrl.cache', () => {
                this.updateSamplePreviewNotice();
            }, true);
        };

        this.collapse = () => {
            if (this.flex1 === 50) {
                this.changeArrow = true;
                this.flex1 = 30;
                this.flex2 = 70;
            } else {
                this.changeArrow = false;
                this.flex1 = 50;
                this.flex2 = 50;
            }
        };

        this.getApp = (appId) => {
            return fetchApp(appId, { App, Includes });
        };

        this.cloneApp = (data) => {
            return App.create(data).$promise;
        };

        this.getAppById = (appId) => {
            return fetchApp(appId, { App, Includes });
        };

        this.clone = (id) => {
            const modalTitle = 'You are just about to clone the existing app';
            const modalConfirmationText =
                'Once cloned you will be taken to the new app view. Make sure you save your changes before cloning.';
            const modalCancelText = 'Cancel';
            const modalConfirmText = 'Clone';
            const modalTypeOverride = 'information';
            const confirmActionFunc = (id) => {
                this.getApp(id)
                    .then((appToClone) => {
                        if (!appToClone) {
                            return console.error('Error cloning app, cannot find app to clone');
                        }

                        const appToCreate = _.omit(appToClone, ['id', 'appTemplate', 'integration']);
                        appToCreate.name = `${appToCreate.name} - copy`;
                        return this.cloneApp(appToCreate);
                    })
                    .then(({ id }) => {
                        return this.getAppById(id);
                    })
                    .then((response) => {
                        return Store.setSingleModelData('apps', response.id, response);
                    })
                    .then((response) => {
                        $state.go('root.my-apps.edit-app', { app: response, appId: response.id });
                    })
                    .catch((error) => {
                        console.error('Error cloning app, error from the API', error);
                    });
            };
            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: modalConfirmationText,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    modalTypeOverride: modalTypeOverride,
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();
                        confirmActionFunc(id);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.getMagicLink = (appId) => {
            return $http.get(`${this.API_URI}/magic-links/for-app/${appId}`).then(({ data }) => data);
        };

        this.setMagicLink = (magicLink) => {
            this.magicLink = magicLink;
            this.magicLinkUrl = buildMagicLinkUrl(this.PLAYER_URI, magicLink && magicLink.token);
        };

        this.regenerateMagicLink = () => {
            const modalTitle = 'You are just about to regenerate this magic link';
            const modalConfirmationText =
                'Once regenerated the current magic link URL will stop working. Any device using it will need the new URL.';
            const modalCancelText = 'Cancel';
            const modalConfirmText = 'Regenerate';
            const modalTypeOverride = 'information';
            const confirmActionFunc = () => {
                $http
                    .post(`${this.API_URI}/magic-links/${this.magicLink.id}/regenerate`)
                    .then(({ data }) => {
                        this.setMagicLink(data);
                        if (!$scope.$$phase) {
                            $timeout(() => {
                                $scope.$apply();
                            });
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        Raven.captureException(error);
                    });
            };
            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: modalConfirmationText,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    modalTypeOverride: modalTypeOverride,
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();
                        confirmActionFunc();
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
                // Stack over (rather than cancel) the magic-link dialog when the
                // regenerate confirm is opened from inside it, so the parent
                // dialog survives and its $watch refreshes the shown URL in place
                // once regenerate resolves. Without this, Angular Material cancels
                // every open dialog before showing a new one. (#841)
                multiple: true,
            });
        };

        this.copyMagicLink = () => {
            ngCopy(this.magicLinkUrl);
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent('Magic link copied')
                    .position('top right')
                    .hideDelay(3000)
            );
        };

        this.openMagicLinkDialog = () => {
            // Defense in depth: the button is hidden for ungated users, but never
            // fetch or reveal the token even if this is invoked another way. (#841)
            if (!this.canManageMagicLink) return;

            const ensureMagicLink = this.magicLink ? $q.resolve() : this.getMagicLink(this.app.id).then(this.setMagicLink);

            ensureMagicLink.then(() => {
                $mdDialog.show({
                    locals: {
                        magicLinkUrl: this.magicLinkUrl,
                    },
                    controller: ($scope, $mdDialog) => {
                        // Keep the URL shown in the dialog in sync with the outer
                        // controller's this.magicLinkUrl, which regenerateMagicLink()
                        // updates once the regenerate call resolves.
                        $scope.$watch(
                            () => this.magicLinkUrl,
                            (magicLinkUrl) => {
                                $scope.magicLinkUrl = magicLinkUrl;
                            },
                        );
                        $scope.copy = () => {
                            this.copyMagicLink();
                        };
                        $scope.regenerate = () => {
                            this.regenerateMagicLink();
                        };
                        $scope.close = () => {
                            $mdDialog.hide();
                        };
                    },
                    controllerAs: '$ctrl',
                    bindToController: true,
                    templateUrl: '/js/components/magic-link-dialog/magic-link-dialog.html',
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                });
            }).catch((error) => {
                // Surface a lazy getMagicLink() failure instead of silently
                // swallowing it and leaving the dialog un-opened. Mirrors the
                // error handling in regenerateMagicLink(). (#841)
                console.error(error);
                Raven.captureException(error);
            });
        };

        this.getAppTemplate = (appTemplateId) => {
            return fetchAppTemplate(appTemplateId, { AppTemplate });
        };

        this.getIntegrationTemplate = (appTemplate) => {
            return IntegrationTemplate.findOne({
                filter: editAppConnect.integrationTemplateLookupFilter(appTemplate.integrationTemplate),
            }).$promise;
        };

        this.setIntegrationTemplate = (integration) => {
            this.integrationTemplate = integration;
        };

        this.getIntegrations = (appTemplate) => {
            return Integration.find({
                filter: {
                    where: { provider: appTemplate.integrationTemplate },
                },
            }).$promise;
        };

        this.setIntegrations = (integrations) => {
            this.integrations = Store.setMultiModelData('integrations', integrations);
        };

        this.getSchemaOverride = (appTemplate) => {
            console.log('getSchemaOverride');
            return $http({
                method: 'GET',
                url: `${appTemplate.appSchemaSource}`,
            });
        };

        this.setSchemaOverride = ({ data }) => {
            const { meta, fields, styles, events } = data;
            if (meta) this.appTemplate.meta = meta;
            if (fields) this.appTemplate.fields = fields;
            if (styles) this.appTemplate.styles = styles;
            if (events) this.appTemplate.events = events;
            // A served schema override REPLACES appTemplate.fields after the
            // initial heal ran, so an old override carrying self-writing
            // expressionProperties (model.limitValue / model.spotlightFilter)
            // would reach formly unhealed. Heal again after applying the override.
            limitControls.healSelfWritingExpressions(this.appTemplate);

            // The override lands asynchronously, after the add branch already
            // seeded defaults from the stored template, so re-seed against the
            // replacement fields: keys the override ADDS would otherwise never be
            // seeded, and a key whose default the override CHANGED would keep the
            // stored template's stale value.
            //
            // Fill-only, deliberately. Reconciling a CHANGED or RETIRED default
            // against the first seed needs provenance for every seeded path, and
            // that machinery proved to be a large and defect-prone surface for a
            // path that cannot run in production: appSchemaSource is only ever
            // set for local development (rocket-api's localAppSourceForSlug is
            // gated on IS_DEVELOPMENT, rocket-apps' buildLocalSourceFields on
            // ROCKET_APPS_LOCAL_SOURCES=1). No published manifest carries it, so
            // on stage/production this branch never executes. The residual
            // dev-only cost is that a default the override changed keeps the
            // stored template's value until the field is touched.
            //
            // Seeding is deliberately NOT deferred until the override arrives:
            // that would put a network round-trip in front of the first preview
            // fetch and reintroduce the empty-preview bug for these templates.
            if (this.mode === 'add' && fields) {
                this.ensurePreviewAppModel();
                seedTemplateDefaults(_.get(this.appTemplate, 'fields.data'), this.app.data);
            }
        };

        this.isEmpty = (obj) => {
            return _.isEmpty(obj);
        };

        this.checkFormDirty = () => {
            this.orientationClicked = true;
        };

        this.onFilesChange = (fileIds) => {
            const containsVideo =
                this.files && fileIds && this.files.some((file) => fileIds.includes(file.id) && file.contentType.startsWith('video'));

            $timeout(() => {
                if (containsVideo) {
                    _.set(this.app, 'settings.animation.type', 'none');
                    _.set(this.animationFormOptions, 'data.disableAnimationType', true);
                    _.set(this.animationFormOptions, 'data.disableAnimationTiming', true);
                    _.set(this.animationFormOptions, 'data.disableAnimationDuration', true);
                } else {
                    _.set(this.animationFormOptions, 'data.disableAnimationType', false);
                    _.set(this.animationFormOptions, 'data.disableAnimationTiming', false);
                    _.set(this.animationFormOptions, 'data.disableAnimationDuration', false);
                }
            });
        };

        this.getFiles = () => {
            this.dataLoaded = false;
            const account = Store.getCurrentAccount();
            const subAccountId = Store.getCurrentSubAccountId();

            const params = {};
            if (subAccountId) {
                _.set(params, 'subAccountId', subAccountId);
            }
            const request = {
                method: 'GET',
                url: `${envService.read('SLS_URI')}/files/list/${account.id}`,
                params,
            };

            return $http(request)
                .then(({ data }) => {
                    const FILES = data.map((file) => {
                        file.fileTypeHeader = '';
                        if (file.contentType.startsWith('video')) {
                            file.fileTypeHeader = 'video';
                        }
                        if (file.contentType.startsWith('image')) {
                            file.fileTypeHeader = 'image';
                        }
                        return file;
                    });

                    $timeout(() => {
                        this.files = Store.setMultiModelData('files', FILES);
                        if (this.app.data) {
                            this.onFilesChange(this.app.data.files);
                        }
                        this.dataLoaded = true;
                    });

                    if (!$scope.$$phase) {
                        $timeout(() => {
                            $scope.$apply();
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.cancel = () => {
            const appId = _.get(this, 'app.id', null);
            const appTemplateType = _.get(this, 'appTemplate.realm', null);
            if (appId) {
                $state.go('root.my-apps');
            } else if (appTemplateType === 'custom') {
                $state.go('root.app-store');
            } else {
                $state.go('root.app-store');
            }
        };

        this.findDisplaysUsingAppId = (appId) => {
            return Display.find({
                filter: {
                    where: { appId },
                    fields: ['id'],
                },
            }).$promise;
        };

        this.findGroupsUsingAppId = (appId) => {
            return Group.find({
                filter: {
                    where: { appId },
                    fields: ['id'],
                },
            }).$promise;
        };
        this.findPlaylists = () => {
            return Playlist.find({
                filter: {
                    fields: ['id', 'apps', 'name'],
                },
            }).$promise;
        };
        this.findPlaylistsUsingApp = (playlists, appId) => {
            const playlistsUsingApp = [];

            playlists.forEach((playlist) => {
                playlist.apps.forEach((appInPlaylist) => {
                    if (appInPlaylist.id === appId) {
                        playlistsUsingApp.push(playlist.name);
                    }
                });
            });
            return playlistsUsingApp;
        };

        this.delete = (id) => {
            Promise.all([this.findDisplaysUsingAppId(id), this.findGroupsUsingAppId(id), this.findPlaylists()]).then(
                ([displaysUsingApp, groupsUsingApp, playlists]) => {
                    const playlistsUsingApp = this.findPlaylistsUsingApp(playlists, id);

                    const displaysUsingAppCount = displaysUsingApp && displaysUsingApp.length;
                    const groupsUsingAppCount = groupsUsingApp && groupsUsingApp.length;
                    const playlistsUsingAppCount = playlistsUsingApp.length;
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    let itemCount1;
                    let itemCount2;
                    let itemCount3;

                    if (displaysUsingAppCount <= 0 && groupsUsingAppCount <= 0 && playlistsUsingAppCount <= 0) {
                        modalTitle = 'Are you sure you want to permanently remove this App?';
                        modalConfirmText = 'Confirm';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (id) => {
                            this.deleteById({ id });
                        };
                    } else {
                        modalTitle = "You can't delete this app as it is being used by :";

                        itemCount1 = displaysUsingAppCount > 0 ? `${displaysUsingAppCount + ' of your displays'}` : null;
                        itemCount2 = groupsUsingAppCount > 0 ? `${groupsUsingAppCount + ' of your groups'} ` : null;
                        itemCount3 = playlistsUsingAppCount > 0 ? `${playlistsUsingAppCount + ' of your playlists'}` : null;

                        modalConfirmationText = 'Please make sure the app is not being used before deleting it.';
                        modalCancelText = 'Ok, I understand';
                    }

                    $mdDialog.show({
                        locals: {
                            title: modalTitle,
                            confirmationText: modalConfirmationText,
                            cancelText: modalCancelText,
                            confirmText: modalConfirmText,
                            itemCount1: itemCount1,
                            itemCount2: itemCount2,
                            itemCount3: itemCount3,
                        },
                        controller: ($scope, $mdDialog) => {
                            $scope.cancel = () => {
                                $mdDialog.hide();
                            };
                            $scope.confirm = () => {
                                $scope.cancel();
                                confirmActionFunc(id);
                            };
                        },
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });
                },
            );
        };

        this.deleteById = ({ id }) => {
            return App.removeById({ id })
                .$promise.then(() => {
                    return Store.removeSingleModelData('app', id);
                })
                .then(() => {
                    $state.go('root.my-apps');
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.save = () => {
            if (this.app.id) {
                const appId = this.app.id;
                //check app being used anywhere
                Promise.all([this.findDisplaysUsingAppId(appId), this.findGroupsUsingAppId(appId), this.findPlaylists()]).then(
                    ([displaysUsingApp, groupsUsingApp, playlists]) => {
                        const playlistsUsingApp = this.findPlaylistsUsingApp(playlists, appId);

                        const displaysUsingAppCount = displaysUsingApp && displaysUsingApp.length;
                        const groupsUsingAppCount = groupsUsingApp && groupsUsingApp.length;
                        const playlistsUsingAppCount = playlistsUsingApp.length;

                        let modalTitle;
                        let modalConfirmationText;
                        let modalCancelText;
                        let modalConfirmText;
                        let confirmActionFunc;
                        let itemCount1;
                        let itemCount2;
                        let itemCount3;

                        this.saveChanges = () => {
                            // Persist first, then make the accepted save live
                            // (#611). A rejected PATCH must never update a
                            // player optimistically.
                            return saveForceEmit.emitSaveForceAfterPersist({
                                WS,
                                appId,
                                appTemplate: this.appTemplate,
                                data: this.app.data,
                                settings: this.app.settings,
                                dynamic: this.dynamic,
                                cache: this.cache,
                                persist: () =>
                                    App.prototype$patchAttributes(
                                        { id: appId },
                                        editAppSavePayload.buildAppUpdatePayload(this.app),
                                    ).$promise,
                            })
                                .then(() => {
                                    this.form.$setPristine();
                                })
                                .catch((error) => {
                                    console.error(error);
                                    Raven.captureException(error);
                                });
                        };

                        if (displaysUsingAppCount > 0 || groupsUsingAppCount > 0 || playlistsUsingAppCount > 0) {
                            modalTitle = 'Any changes made now to this app wil be also applied to:';

                            itemCount1 = displaysUsingAppCount > 0 ? `${displaysUsingAppCount + ' of your displays'}` : null;
                            itemCount2 = groupsUsingAppCount > 0 ? `${groupsUsingAppCount + ' of your groups'} ` : null;
                            itemCount3 = playlistsUsingAppCount > 0 ? `${playlistsUsingAppCount + ' of your playlists'}` : null;

                            modalConfirmationText = 'as the app is being used by the above.';
                            modalConfirmText = 'Apply changes';
                            modalCancelText = 'Cancel';
                            const modalTypeOverride = 'information';

                            confirmActionFunc = () => {
                                this.saveChanges();
                            };
                            $mdDialog.show({
                                locals: {
                                    title: modalTitle,
                                    confirmationText: modalConfirmationText,
                                    cancelText: modalCancelText,
                                    confirmText: modalConfirmText,
                                    itemCount1: itemCount1,
                                    itemCount2: itemCount2,
                                    itemCount3: itemCount3,
                                    modalTypeOverride: modalTypeOverride,
                                },
                                controller: ($scope, $mdDialog) => {
                                    $scope.cancel = () => {
                                        $mdDialog.hide();
                                    };
                                    $scope.confirm = () => {
                                        $scope.cancel();
                                        confirmActionFunc();
                                    };
                                },
                                controllerAs: '$ctrl',
                                bindToController: true,
                                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                                parent: angular.element('body'),
                                clickOutsideToClose: true,
                                escapeToClose: true,
                            });
                        } else {
                            this.saveChanges();
                        }
                    },
                );
            } else {
                App.create(editAppSavePayload.buildAppCreatePayload(this.app, this.appTemplate))
                    .$promise.then((app) => {
                        $state.go('root.my-apps.edit-app', { appId: app.id, preview: _.clone(this.dynamic) });
                    })
                    .catch((error) => {
                        console.error(error);
                        Raven.captureException(error);
                    });
            }
        };

        this.connect = () => editAppConnect.connectEditAppIntegration({
            integrationTemplate: this.integrationTemplate,
            app: this.app,
            form: this.form,
            integrations: this.integrations,
            envService,
            Popup,
            Integration,
            Includes,
            ListModifier,
            $mdDialog,
            $timeout,
            Raven,
        });

        this.shouldShowIntegrations = () => {
            const { integrationTemplate } = this.appTemplate || {};
            return integrationTemplate && !integrationTemplate.startsWith('rocket-');
        };

        this.canUseSamplePreview = () => canUseSamplePreview({
            enabled: this.samplePreviewEnabled,
            mode: this.mode,
            slug: _.get(this.appTemplate, 'slug'),
        });

        this.hasSelectedIntegration = () => !!(
            _.get(this.app, 'integrationId') || _.get(this.app, 'integration.id')
        );

        this.canShowAppSettings = () => {
            const integrationTemplate = _.get(this.appTemplate, 'integrationTemplate');
            const normallyVisible = !integrationTemplate
                || integrationTemplate.startsWith('rocket-')
                || this.hasSelectedIntegration();
            return normallyVisible || (this.canUseSamplePreview() && this.previewDataSource === 'sample');
        };

        this.isMissingRequiredIntegration = () => {
            if (!this.canUseSamplePreview()) {
                return false;
            }

            if (!_.get(this.appTemplate, 'integrationTemplate')) {
                return false;
            }

            if (this.hasSelectedIntegration()) {
                return false;
            }

            if (this.previewDataSource === 'sample') {
                return false;
            }

            return true;
        };

        this.ensurePreviewAppModel = () => {
            this.app = this.app || {};
            this.app.data = this.app.data || {};
            this.app.settings = this.app.settings || {};
        };

        this.updateSamplePreviewNotice = () => {
            const slug = _.get(this.appTemplate, 'slug');
            const isSample = this.previewDataSource === 'sample';
            const previewBody = getPreviewNoticeBody({
                isSample,
                slug,
                appData: _.get(this.app, 'data', {}),
                now: this.samplePreviewNow,
                dynamic: this.dynamic,
                cache: this.cache,
            });
            this.samplePreviewNotice = getSamplePreviewNotice({
                isSample,
                slug,
                appData: _.get(this.app, 'data', {}),
                body: previewBody,
            });
        };

        this.useSamplePreview = () => {
            if (!this.canUseSamplePreview()) return;
            this.ensurePreviewAppModel();
            this.previewDataSource = 'sample';
            this.previewRequestId += 1;
            this.errors.preview = null;
            this.updateSamplePreviewNotice();
        };

        this.useLivePreview = () => {
            if (!this.canUseSamplePreview()) return;
            this.previewDataSource = 'live';
            this.previewRequestId += 1;
            this.updateSamplePreviewNotice();
        };

        this.onError = ({ name, value }) => {
            $timeout(() => {
                if (name) this.errors[name] = value;
                $scope.$apply();
            });
        };
    }

    module
        .config(function ($stateProvider) {
            $stateProvider
                .state('root.my-apps.edit-app', {
                    url: '/:appId',
                    data: {
                        pageTitle: 'APPS_VIEW.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<edit-app-component />',
                        },
                    },
                    params: {
                        route: { value: 'edit' },
                        appId: { value: null },
                        preview: { value: null },
                        app: { value: null },
                    },
                })
                .state('root.app-store.add-app', {
                    url: '/:appTemplateId/add',
                    data: {
                        pageTitle: 'APPS_VIEW.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<edit-app-component />',
                        },
                    },
                    params: {
                        route: { value: 'add' },
                        appTemplateId: { value: null },
                        appTemplate: { value: null },
                    },
                });
        })
        .component('editAppComponent', {
            templateUrl: '/js/my-apps/edit-app/edit-app.html',
            controller: EditAppCtrl,
        });
})(angular.module('rocket.components'));
